import React from 'react';
import { ModuleBase, Stack, HeadingTag, Link, ResponsiveImage } from '@/components';
import { SideBySideModuleModel } from './SideBySideModule';
import { fadeIn } from '@/animations';

const HomepageCreateBetterFutures = (data: SideBySideModuleModel) => {
  const {
    props: { image, link1, link2, title },
  } = data;

  return (
    <ModuleBase
      data={{ ...data, props: { ...data.props, backgroundColour: '#305545' } }}
      noPadding
      className="HomepageCreateBetterFutures flex snap-end flex-col items-center justify-end overflow-hidden md:h-[calc(100vh-var(--header-height))] lg:flex-row"
    >
      <div className="relative aspect-square w-full overflow-hidden lg:hidden">
        {image && image.desktopImage && (
          <ResponsiveImage
            animation={fadeIn}
            image={image.desktopImage}
            widths={{ xs: 425, sm: 650, md: 768, lg: 1, xl: 1, xxl: 1 }}
            heights={{ xs: 425, sm: 650, md: 768, lg: 1, xl: 1, xxl: 1 }}
          />
        )}
        <div className="absolute top-2/4 left-2/4 block aspect-square w-full -translate-x-2/4 -translate-y-2/4 rounded-full border border-white lg:h-auto lg:w-full" />
      </div>

      <Stack className="left-0 flex h-full w-full items-center lg:absolute lg:h-auto">
        <div className="container flex h-full px-0 lg:justify-start">
          <div className="info-block-stats flex flex-col justify-around gap-10 px-9 py-10 lg:h-[calc(100vh-var(--header-height))] lg:w-1/2 lg:justify-center lg:gap-0 lg:py-18">
            <div className="w-full lg:flex-grow xl:w-3/4">
              {title && (
                <HeadingTag
                  tag="h2"
                  heading={title}
                  role="contentinfo"
                  aria-label="contentinfo"
                  dontAddClassFromTag
                  className="text-style-h1 text-[80px] leading-[70px] text-[#7fd3a0] md:pb-10 md:text-[120px] md:leading-[110px] lg:text-[140px] lg:leading-[120px] xl:pb-18"
                />
              )}
            </div>
            <div className="flex flex-col gap-4 sm:gap-5 md:flex-row lg:gap-5">
              {link1 && (
                <Link
                  animate
                  className="btn v2 group btn-from-bg primary !text-[#305545] hover:!text-white"
                  link={link1}
                />
              )}
              {link2 && <Link animate className="btn v2 group btn-from-bg secondary" link={link2} />}
            </div>
          </div>
        </div>
      </Stack>
    </ModuleBase>
  );
};

export default HomepageCreateBetterFutures;
